<template>
    <b-card :title="title">
        <p class="mt-3">
            Page: {{ pagination.page }} of {{ pageCount }} Total:
            {{ pagination.total }}
        </p>
        <b-card-header>
            <b-row>
                <!-- <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="selectionType"
                            v-model="isOfficerSection"
                            :aria-describedby="ariaDescribedby"
                            name="isOfficerSection"
                        >
                            <b-form-radio :value="false"
                                >By Location</b-form-radio
                            >
                            <b-form-radio :value="true"
                                >By Officer</b-form-radio
                            >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col> -->

                <label for="input-location" class="mt-1"
                    >Warehouse/Location:</label
                >
                <b-col v-show="!islocationSection">
                    <b-form-select
                        id="input-location"
                        v-model="filters.location_id"
                        :options="locations"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Select All
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <label for="input-type" class="mt-1">Item Type:</label>
                <b-col v-show="!istypeSection">
                    <b-form-select
                        id="input-type"
                        v-model="filters.order_item_type_id"
                        :options="types"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Select All
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <label for="input-1" class="mt-1">Officer:</label>
                <b-col v-show="!isOfficerSection">
                    <b-form-select
                        id="input-1"
                        v-model="filters.officer_id"
                        :options="users"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Select All
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <label for="input-product" class="mt-1">Product:</label>
                <b-col v-show="!isProduct">
                    <b-form-input
                        id="input-product"
                        v-model="filters.product_search"
                        value-field="id"
                        text-field="name"
                        placeholder="Keyword Search"
                        block
                    >
                        <!-- <template #first>
                        <b-form-sel :value="null" disabled>
                            Select Section
                        </b-form-sel>
                    </template> -->
                    </b-form-input>
                </b-col>

                <label for="input-section">Section:</label>
                <b-col v-show="!isSectionSection">
                    <b-form-input
                        id="input-section"
                        v-model="filters.section_search"
                        value-field="id"
                        text-field="name"
                        placeholder="Keyword Search"
                        block
                    >
                        <!-- <template #first>
                                <b-form-sel :value="null" disabled>
                                    Select Section
                                </b-form-sel>
                            </template> -->
                    </b-form-input>
                </b-col>
                <!-- <b-col md="2" cols="12">
                    <slot></slot>
                </b-col> -->
                <download-excel
                    :fields="json_fields"
                    :data="sectionMasterItemsExcel"
                    name="warehouse-inventory.xls"
                >
                    <b-button class="">Export</b-button>
                </download-excel>

                <!-- <b-col v-show="isOfficerSection">
                    <b-form-select
                        id="input-1"
                        v-model="user_id"
                        :options="users"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Officer
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col v-show="!isOfficerSection">
                    <b-form-select
                        id="input-location"
                        v-model="location_id"
                        :options="locations"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Select Warehouse
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col v-show="!isOfficerSection">
                    <b-form-select
                        id="input-section"
                        v-model="section_id"
                        :options="sections"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Select Section
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col> -->
            </b-row>
        </b-card-header>
        <b-card-body>
            <!-- <b-button-group class="float-right">
                <b-button
                    variant="secondary"
                    @click="exportMasterItems()"
                    v-if="hasPermissionView"
                >
                    <b-spinner small v-if="loading"></b-spinner>
                    <span v-else> Export</span>
                </b-button>
            </b-button-group> -->
            
            <label for="bulk">Bulk:</label>
            <b-button
                size="lg"
                :to="``"
                class="ml-2"
                variant="primary"
                :botton-action="bulkTransfer"
                @click="bulkTransfer()"
            >
                Bulk Transfer
            </b-button>
       

            <b-table
                :items="sectionMasterItems"
                :fields="itemFields"
                striped
                hover
                :busy="tableLoading"
                :filter="filters"
                responsive
                :per-page="itemsPerPage"
                :current-page="currentPage"
                selectable
                @row-selected="onRowSelected"
                ref="selectable"
            >
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #head(check)>
                    <b-form-checkbox
                        v-if="sectionMasterItems.length > 0"
                        :checked="
                            sectionMasterItems.length ===
                            selectedsectionMasterItems.length
                        "
                        @change="toggleAllRow()"
                    ></b-form-checkbox>
                </template>

                <template #cell(check)="{ rowSelected, index }">
                    <b-form-checkbox
                        :checked="rowSelected"
                        @change="toggleRow(index, rowSelected)"
                    ></b-form-checkbox>
                </template>

                <template #cell(actions)="{ item }">
                    <b-button
                        size="sm"
                        class="mr-2"
                        @click="transfer(item)"
                        variant="primary"
                    >
                        Transfer
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'
export default {
    name: 'SectionItems-ListItems',
    props: ['type', 'title', 'item'],
    // mixins: [popupMixins, permissionsMixins],
    mixins: [
        popupMixins,
        reportMixins,
        permissionsMixins,
        showItemHelper,
        importMixins,
    ],

    data() {
        return {
            tableLoading: false,
            query: '',
            filters: {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                product_search: null,
                section_search: null,
            },
            itemsPerPage: 15,
            currentPage: 0,
            selectedIds: [],
            trasnferItems: '',
            selectedsectionMasterItems: [],
            islocationSection: false,
            isOfficerSection: false,
            istypeSection: false,
            isProduct: false,
            isSectionSection: false,
            section_id: null,
            user_id: null,
            location_id: null,
            bulkAction: 'none',
            type_id: null,
            reportType: 'master_item_details',
            json_fields: {
                'Product Name': 'name',
                Type: 'type',
                Warehouse: 'warehouse',
                Location: 'location',
                Officer: 'officer',
                Vendor: 'vendor',
                UOM: 'uom',
                Price: 'price',
                Quantity: 'quantity',
            },

            itemFields: [
                'check',
                'actions',
                'name',

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },

                {
                    key: 'Warehouse',
                    label: 'Warehouse',
                    formatter: (value, key, item) =>
                        item.sections[0] &&
                        item.sections[0].location_section.location.name,
                },

                {
                    key: 'Location',
                    label: 'Location',
                    formatter: (value, key, item) =>
                        item.sections[0] &&
                        item.sections[0].location_section.name,
                },
                {
                    key: 'Officer',
                    label: 'Officer',
                    formatter: (value, key, item) =>
                        item.sections[0] &&
                        item.sections[0].location_section.officers[0] &&
                        item.sections[0].location_section.officers[0]
                            .first_name,
                },

                {
                    key: 'vendor_id',
                    label: 'Vendor',
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    // formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) => item.selling_price,
                },
                {
                    key: 'quantity',
                    label: 'Quantity',
                    formatter: (value, key, item) =>
                        item.sections[0] && item.sections[0].quantity_on_hand,
                },
            ],
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        pagination() {
            return this.$store.state.masterItem.sectionPagination || {}
        },
        locations() {
            console.log(
                '..............location.......',
                this.$store.state.locations
            )
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            )
        },
        sections() {
            const { location_id } = this
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },
        sectionMasterItems() {
            const _items = this.$store.state.masterItem.section_items
            // const _items = this.$store.state.masterItem.section_item.map(x => {
            // alert(this.$store.state.masterItem.section_items.length)
            // x.quantity = $this.getSectionQuantity(
            //     x.sections,
            //     this.section_id
            // )
            // x.actions='View';

            // if(x.sections[0].location_section.officers && x.sections[0].location_section.officers.length >0){
            //                x.officer =  x.sections[0].location_section.officers[0].first_name + " " + x.sections[0].location_section.officers[0].last_name;

            //             }
            //             else{
            //                 x.officer = "N/A";

            //             }

            //  return x
            // })
            console.log('master items=================', _items)

            return _items
            //return _items.filter(x => x.quantity !== 0)
        },
        sectionMasterItemsExcel() {
            // console.log("MasterItems-----",this.$store.state.masterItem.section_items.section_master);
            var exportData = []
            this.$store.state.masterItem.section_items.forEach(item => {
                var exportItem = {}
                exportItem.name = item.type && item.type.name
                exportItem.code = item.ext_reference_code
                exportItem.type = item.type && item.type.name
                exportItem.warehouse =
                    item.sections[0] &&
                    item.sections[0].location_section.location.name
                exportItem.location =
                    item.sections[0] && item.sections[0].location_section.name
                exportItem.officer =
                    item.sections[0] &&
                    item.sections[0].location_section.officers[0] &&
                    item.sections[0].location_section.officers[0].first_name
                exportItem.vendor = item.vendor && item.vendor.name
                exportItem.uom = item.uom
                exportItem.price = item.selling_price
                exportItem.quantity =
                    item.sections[0] && item.sections[0].quantity_on_hand
                exportData.push(exportItem)
            })

            return exportData
        },

        users() {
            return this.$store.getters['users/sorted_officers']
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        rows() {
            return this.$store.state.masterItem.section_items.length
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            //console.log("query:", query)
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        user_id: function (id) {
            //console.log('id====================', id)
            const user = this.users.find(x => x.id == id)
            //console.log("user",user)
            if (user) this.section_id = user.location_section_id
            else this.section_id = null
            //console.log('this.section_id', this.section_id)
        },
        sectionMasterItems: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },

        // user_id: function (id) {
        //     console.log('id====================', id)

        //     // if (id) this.$store.dispatch(`masterItem/fetchBySection?officer=`+id`+`, id)
        //     // else this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
        // },
        section_id: function (id) {
            //console.log('id====================', id)
            if (id) this.$store.dispatch('masterItem/fetchBySection', id)
            else this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
        },

        isOfficerSection: function () {
            this.section_id = null
            this.location_id = null
            this.user_id = null
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('masterItem/fetchSection')
        this.$store.dispatch('masterItem/fetchallMaster')
    },

    methods: {
        // exportMasterItems() {
        //     console.log("TESTTEST:", this.$refs.selectable)
        //     this.$refs.selectable.generateReport()
        //     console.log("...........export......")
        // },
        // changeFilters(value) {
        //     console.log('filters before', value)
        //     for (const key in defaultModel) {
        //         this.$set(this.model, key, value[key] || defaultModel[key])
        //     }
        //     console.log('filters after', this.model)
        // },
        getQueryString(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type

            //console.log("queryModel:::", queryModel)
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        viewItem(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            let {
                query,
                pagination: { page },
                filters,
            } = this
            if (!parseInt(filters.location_id, 10)) {
                filters.location_id = null
            }

            if (!parseInt(filters.order_item_type_id, 10)) {
                filters.order_item_type_id = null
            }
            if (!parseInt(filters.officer_id, 10)) {
                filters.officer_id = null
            }

            this.tableLoading = true
            this.$router.push({
                query: { page, query, ...filters },
            })
            this.$store.dispatch('masterItem/fetchSection', {
                query,
                page,
                filters,
            })
        },

        getSectionQuantity(sections, section_id) {
            sections = sections || []
            if (section_id) {
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                if (!section) return 0
                return section.quantity_on_hand
            } else {
                return sections.reduce((_sum, section) => {
                    _sum += section.quantity_on_hand
                }, 0)
            }
        },

        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onRowSelected(items) {
            this.selectedsectionMasterItems = items
            //localStorage.setItem("cars", JSON.stringify(this.selectedsectionMasterItems));
            localStorage.storedData = JSON.stringify(
                this.selectedsectionMasterItems
            )
            // return items
            //this.cars = JSON.parse(localStorage.getItem("cars"));
            // console.log('Local item', JSON.parse(localStorage.storedData))
        },
        selectAllRows() {
            //console.log("asdsa")
            this.$refs.selectable && this.$refs.selectable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectable && this.$refs.selectable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.selectable.unselectRow(index)
            else this.$refs.selectable.selectRow(index)
        },

        toggleAllRow() {
            if (
                this.sectionMasterItems.length ===
                this.selectedsectionMasterItems.length
            )
                this.$refs.selectable.clearSelected()
            else this.$refs.selectable.selectAllRows()
        },
        transfer(item) {
            localStorage.storedData = JSON.stringify([item])
            this.$router.push({ path: '/admin/transfer-section-items/' })
        },

        bulkTransfer() {
            if(this.selectedsectionMasterItems.length>0){
            this.$router.push({ path: '/admin/transfer-section-items/' })
            }else{
                this.genericToast(
                    "Trasnfer",
                    'Error!',
                    'danger',
                    `Please Select atleast one item for Bulk transfer`
                )
            }
        },
    },
}
</script>
